// The browser raises these itself on an input carrying a type, pattern, min, max, step or length
// constraint, and rrf records them in the field's errors like any other. An Errors component with
// no message for a key renders nothing at all, so without these the field is invalid, the Save
// button greys out and the screen says nothing about why. Any input with one of those constraints
// needs them.
//
// min and max are woven into the message when the caller knows them, because "Value is too small"
// on its own does not tell an admin what to type instead.
export const nativeValidationMessages = ({ min, max } = {}) => ({
  badInput: 'Value is not a number',
  typeMismatch: 'Value is not in the expected format',
  patternMismatch: 'Value does not match the required pattern',
  stepMismatch: 'Value is not one of the allowed steps',
  tooShort: 'Value is too short',
  tooLong: 'Value is too long',
  rangeUnderflow: min === undefined || min === null ? 'Value is too small' : `Value must be ${min} or more`,
  rangeOverflow: max === undefined || max === null ? 'Value is too large' : `Value must be ${max} or less`
});

export default nativeValidationMessages;
